import StreamingPane from '../../presentational/streamingPane';
import apiService from '../../../services/apiService';
import frontendLog from '../../../libs/frontendLog';
import FeaturedStreamersActionCreator from '../../../actions/featuredStreamersActionCreator';
import _ from 'lodash';

export type TFeaturedStreamsPaneProps = {
  enabled: boolean;
  hiddenWhenSmall?: boolean;
};

export function FeaturedStreamsPane(props: TFeaturedStreamsPaneProps) {
  if (!props.enabled) {
    return null;
  }

  return (
    <div className="rio-featured-streams-pane">
      <StreamingPane className={props.hiddenWhenSmall ? 'rio-hidden--small' : ''} />
    </div>
  );
}

(FeaturedStreamsPane as any).preloadComponentActions = async (props: TFeaturedStreamsPaneProps, params: any) => {
  if (!props.enabled) {
    return Promise.resolve([]);
  }
  return _.flatten(
    await Promise.all([
      new Promise((resolve: any, reject: any) => {
        const loadParams = {
          type: 'popular-streamers'
        };
        apiService.getFeaturedStreamers(loadParams, (err: any, result?: any) => {
          if (err) {
            frontendLog.error({ err }, 'getFeaturedStreamers failed');
            reject(err);
          }

          if (!result) {
            frontendLog.error('getFeaturedStreamers failed');
            reject(new Error('getFeaturedStreamers failed'));
          }

          resolve([FeaturedStreamersActionCreator.setFeaturedStreamers(loadParams.type, result)]);
        });
      })
    ])
  );
};
